<template>
  <div
    v-if="selectedCompany.Location"
    :style="alertStyle"
    class="alert p-2 mt-2 alert-color"
    role="alert"
  >
    <h3 class="font-weight-bold pr-2">{{ $t("message.pickUpFrom") }}</h3>
    <div class="row">
      <div class="col-sm-12">
        <p class="mb-1">{{ selectedCompany.Name }}</p>
        <p class="mb-1">{{ selectedCompany.Location.Address }}</p>
        <p class="mb-1">{{ selectedCompany.Location.State }}, {{ selectedCompany.Location.Suburb }}</p>
        <p class="mb-1">
          {{ $t("message.getDirections") }}:
          <img
            :src="googlemapImg"
            class="google-map-img"
            style="vertical-align: bottom;"
            alt="view in google map"
            title="Direction"
            @click="GoGoogleMap"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import googlemap from "./../../../../assets/google-maps.png";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["mobileStyles", "desktopStyles", "selectedCompany"]),
    googlemapImg() {
      return googlemap;
    },
    alertStyle() {
      return this.isMobile()
        ? this.mobileStyles.primaryBodyBackground
        : this.desktopStyles.primaryBodyBackground;
    }
  },
  methods: {
    GoGoogleMap() {
      if (this.selectedCompany.Location.Address) {
        var address =
          this.selectedCompany.Location.Address +
          ", " +
          (this.selectedCompany.Location.Suburb
            ? this.selectedCompany.Location.Suburb
            : "") +
          " " +
          (this.selectedCompany.Location.State
            ? this.selectedCompany.Location.State
            : "") +
          " " +
          (this.selectedCompany.Location.Postcode
            ? this.selectedCompany.Location.Postcode
            : "") +
          ", " +
          (this.selectedCompany.Location.Country
            ? this.selectedCompany.Location.Country
            : "");
        var url = "http://www.google.com/maps/place/" + address;
        window.open(url);
      }
    }
  }
};
</script>
